import { AUDIO_CLUE_SOUND_DEFINITIONS } from "./audioClueNotes";

export const GAME_SOUND_DEFINITIONS = {
  spin_wheel: [
    { action_key: "bg_music", label: "Background music", loop: true, default_volume: 0.4 },
    { action_key: "intro_music", label: "Intro music (Play with Host)", loop: true, default_volume: 0.4 },
    {
      action_key: "game_about_to_start",
      label: "Game about to start (light BG)",
      loop: true,
      default_volume: 0.35,
    },
    { action_key: "building_wheel", label: "Building the wheel", loop: true, default_volume: 0.35 },
    { action_key: "spin_start", label: "Spin start", loop: false, default_volume: 1 },
    { action_key: "winner", label: "Winner reveal", loop: false, default_volume: 1 },
    // Enhanced Hot Seat flow — one-shot SFX for each button
    { action_key: "btn_start", label: "BTN 1 — Start (Invite)", loop: false, default_volume: 1 },
    { action_key: "btn_announce", label: "BTN 2 — Announce wheel", loop: false, default_volume: 1 },
    { action_key: "btn_hot_seat", label: "BTN 3 — Select Hot Seat", loop: false, default_volume: 1 },
    { action_key: "btn_lucky", label: "BTN 4 — Lucky Player", loop: false, default_volume: 1 },
    { action_key: "btn_build", label: "BTN 5 — Build User Wheel", loop: false, default_volume: 1 },
    { action_key: "btn_countdown", label: "BTN 6 — Countdown 3..2..1", loop: false, default_volume: 1 },
    { action_key: "btn_go", label: "BTN 7 — Start Actual Wheel", loop: false, default_volume: 1 },
    // Enhanced Hot Seat flow — BG music per phase
    { action_key: "invite_bg", label: "Invite phase BG music", loop: true, default_volume: 0.4 },
    { action_key: "announce_bg", label: "Announce phase BG music", loop: true, default_volume: 0.4 },
    { action_key: "hot_seat_slide_bg", label: "Hot seat slide BG music", loop: true, default_volume: 0.4 },
    { action_key: "lucky_player_bg", label: "Lucky player BG music", loop: true, default_volume: 0.4 },
    { action_key: "countdown_tick", label: "Countdown tick sound", loop: false, default_volume: 1 },
  ],
  beerillioner: [
    { action_key: "bg_music", label: "Background music (no active session)", loop: true, default_volume: 0.4 },
    { action_key: "first_intro_bg", label: "1st Intro Bg", loop: true, default_volume: 0.4 },
    { action_key: "session_start_clap", label: "FFF — Start game clap", loop: false, default_volume: 1 },
    { action_key: "bg_music_2", label: "FFF — Get ready BG music", loop: true, default_volume: 0.4 },
    { action_key: "fff_intro", label: "FFF — Intro BG music", loop: true, default_volume: 0.4 },
    { action_key: "fff_question_reading", label: "FFF — Question reading BG music", loop: true, default_volume: 0.4 },
    { action_key: "show_all_options", label: "FFF — Show all options", loop: false, default_volume: 1 },
    { action_key: "show_option", label: "FFF — Show single option", loop: false, default_volume: 1 },
    { action_key: "fff_timer_bg", label: "FFF — Timer BG music", loop: true, default_volume: 0.4 },
    { action_key: "fff_timer_end", label: "FFF — Timer end", loop: false, default_volume: 1 },
    { action_key: "fff_leaderboard", label: "FFF — Leaderboard BG music", loop: true, default_volume: 0.4 },
    { action_key: "fff_hot_seat", label: "FFF — Hot seat selected (claps)", loop: false, default_volume: 1, default_audio_url: "https://cdn.pixabay.com/audio/2022/11/04/audio_7b2d96a98f.mp3" },
    { action_key: "mg_intro", label: "Main game — Intro", loop: false, default_volume: 1 },
    { action_key: "mg_bg", label: "Main game — Background music", loop: true, default_volume: 0.4 },
    { action_key: "mg_lock", label: "Main game — Lock answer", loop: false, default_volume: 1 },
    { action_key: "correct", label: "Correct answer", loop: false, default_volume: 1 },
    { action_key: "wrong", label: "Wrong answer", loop: false, default_volume: 1 },
    { action_key: "win", label: "Game won", loop: false, default_volume: 1 },
  ],
  higher_or_lower: [
    { action_key: "prep_bg", label: "Prep Bg music", loop: true, default_volume: 0.4 },
    { action_key: "start_session_countdown", label: "Start Session Countdown", loop: false, default_volume: 1 },
    { action_key: "building_user_music", label: "Building the user Music", loop: true, default_volume: 0.35 },
    { action_key: "countdown_wheel", label: "Countdown wheel", loop: false, default_volume: 1 },
    { action_key: "spinning_sound", label: "Spinning sound", loop: false, default_volume: 1 },
    { action_key: "correct", label: "Correct guess", loop: false, default_volume: 1 },
    { action_key: "wrong", label: "Wrong guess", loop: false, default_volume: 1 },
    { action_key: "win", label: "Game completed", loop: false, default_volume: 1 },
    {
      action_key: "hot_seat",
      label: "Hot seat selected (claps)",
      loop: false,
      default_volume: 1,
      default_audio_url: "https://cdn.pixabay.com/audio/2022/11/04/audio_7b2d96a98f.mp3",
    },
    {
      action_key: "card_flip",
      label: "Card flip / reveal",
      loop: false,
      default_volume: 1,
      default_audio_url: "https://cdn.pixabay.com/audio/2022/03/15/audio_e385f1aa0d.mp3",
    },
    ...AUDIO_CLUE_SOUND_DEFINITIONS,
  ],
  prize_palette: [
    { action_key: "collage_show", label: "Collage show", loop: false, default_volume: 1 },
    { action_key: "prize_show", label: "Prize show", loop: false, default_volume: 1 },
    { action_key: "prize_award", label: "Prize award", loop: false, default_volume: 1 },
    { action_key: "spin_wheel_show", label: "Spin the wheel show", loop: false, default_volume: 1 },
  ],
};

export const GAME_LABELS = {
  spin_wheel: "Spin the Wheel",
  beerillioner: "Beer Millionaire",
  higher_or_lower: "Higher or Lower",
  prize_palette: "Prize Palette",
};
